import { FC } from 'react';
import { useTranslations } from 'next-intl';
import './Banner.scss';
import Image from 'next/image';
interface BannerProps {
  onCtaClick: () => void;
  handleCloseBanner: () => void;
}
const Banner: FC<BannerProps> = ({
  onCtaClick,
  handleCloseBanner
}) => {
  const t = useTranslations();
  return <div className="banner py-2" data-sentry-component="Banner" data-sentry-source-file="Banner.tsx">
            <div className="row justify-content-between container">
                <div className="text col-3 d-md-block d-none">
                    <Image src="/assets/icons/virtuzone.svg" loading="lazy" width={98} height={34} alt="virtuzone" data-sentry-element="Image" data-sentry-source-file="Banner.tsx" />
                </div>
                <div className="text col-md-6 col-12 text-center d-flex justify-content-center">
                    <h3 className="mt-md-2 mt-0">
                        {t('banner.title1')} <span>{t('banner.title2')}</span>{' '}
                        {t('banner.title3')}
                    </h3>{' '}
                    <div className="link mx-3 mt-1 d-md-none d-flex close-icon mt-2 " onClick={handleCloseBanner}>
                        <Image src="/assets/icons/banner.svg" loading="lazy" width={12} height={10} alt="apple-store" data-sentry-element="Image" data-sentry-source-file="Banner.tsx" />
                    </div>
                </div>
                <div className="d-flex col-md-3 col-6 justify-content-end d-md-flex d-none">
                    <div className="app pt-lg-2 d-flex justify-content-center" onClick={onCtaClick}>
                        <Image src="https://hotdesk-assets.s3.eu-west-1.amazonaws.com/landing_pages/web_v2/icons/g_play.svg" loading="lazy" className="mx-1 mt-1" width={16} height={17} alt="google_play" data-sentry-element="Image" data-sentry-source-file="Banner.tsx" />
                        <Image src="https://hotdesk-assets.s3.eu-west-1.amazonaws.com/landing_pages/web_v2/icons/apple.svg" loading="lazy" className="mx-1 mt-1" width={16} height={17} alt="apple-store" data-sentry-element="Image" data-sentry-source-file="Banner.tsx" />
                        <p className="m-0 mx-1">{t('banner.btn')}</p>
                    </div>
                    <div className="link mx-3 mt-1 d-flex close-icon mt-3" onClick={handleCloseBanner}>
                        <Image src="/assets/icons/banner.svg" loading="lazy" width={12} height={10} alt="x-icon" data-sentry-element="Image" data-sentry-source-file="Banner.tsx" />
                    </div>
                </div>
            </div>
        </div>;
};
export default Banner;